import type { FC } from 'react'

import { Radio, RadioGroup, Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'
import { useOnboardingForm } from '@/forms/hooks'
import type { OnboardingFormFields } from '@/forms/onboarding/types'

import './CurrentOwner.styles.scss'

const CurrentOwner: FC<{ values: OnboardingFormFields }> = ({ values }) => {
  const { data } = useOnboardingForm()

  return (
    <div className="current-owner">
      <h4>
        <Text id="Hvem eier nummeret i dag?" />
      </h4>

      <RadioGroup id="userIsOwner">
        <Field name="userIsOwner">
          {({ field, form }: FieldProps) => (
            <Radio
              id="userIsOwner-true"
              label={<Text id="Jeg eier nummeret" />}
              marginBottom={16}
              isDisabled={!data.isEditable}
              onFieldChange={() => {
                if (!form.values.isCreditCheckAccepted) return
                form.setFieldValue('isCreditCheckAccepted', false)
                form.setFieldTouched('isCreditCheckAccepted', false)
              }}
              {...field}
              checked={field.value === true}
              onChange={() => form.setFieldValue('userIsOwner', true)}
            />
          )}
        </Field>

        <Field name="userIsOwner">
          {({ field, meta, form }: FieldProps) => (
            <Radio
              id="userIsOwner-false"
              label={<Text id="Annen eier" />}
              marginBottom={16}
              isDisabled={!data.isEditable}
              error={meta.error}
              touched={meta.touched}
              {...field}
              checked={field.value === false}
              onChange={() => form.setFieldValue('userIsOwner', false)}
            />
          )}
        </Field>
      </RadioGroup>

      {!values.userIsOwner && (
        <div className="current-owner-details">
          <Field name="companyName">
            {({ field, meta }: FieldProps) => (
              <Input
                id="companyName"
                marginRight={16}
                label={<Text id="Firmanavn / Navn" />}
                error={meta.error}
                touched={meta.touched}
                isDisabled={!data.isEditable}
                {...field}
              />
            )}
          </Field>

          <Field name="birthdateOrgNo">
            {({ field, meta }: FieldProps) => (
              <Input
                id="birthdateOrgNo"
                label={<Text id="Org.nr/ Fødelsnummer" />}
                error={meta.error}
                touched={meta.touched}
                isDisabled={!data.isEditable}
                {...field}
              />
            )}
          </Field>
        </div>
      )}
    </div>
  )
}

export default CurrentOwner
